export const BankAccountType = {
    LivretA : {accountType: "LivretA", name: 'Livret A'},
    Ldds : {accountType:"Ldds", name: 'Livret de développement durable et solidaire (LDDS)'},
    Lep : {accountType: "Lep", name: "Livret d'épargne populaire (lep)"},
    LivretJeune : {accountType:"LivretJeune", name: 'Livret jeune'},
    Cel : {accountType:"Cel", name: 'Compte épargne logement (CEL)'},
    Pel : {accountType:"Pel", name: 'Plan épargne logement (PEL)'},
    Perp : {accountType:"Perp", name: "Plan d'épargne retraite populaire (PERP)"},
    LivretEpargneBancaire : {accountType:"LivretEpargneBancaire", name: "Livret d'épargne bancaire"},
    Cat : {accountType:"Cat", name: 'Compte à terme (CAT)'},
    CoffreFortBancaire : {accountType:"CoffreFortBancaire", name: 'Coffre fort bancaire'},
    PasPlacements: {accountType: "PasPlacements", name: "Pas de placements"},
    AssuranceDeces : {accountType:"AssuranceDeces", name: 'Décès'},
    AssuranceObseque : {accountType:"AssuranceObseque", name: 'Obsèques'},
    AssuranceVie : {accountType:"AssuranceVie", name: 'Vie'},
    PasAssurance: {accountType:"PasAssurance", name: "Pas d'assurance"},
    CreditVoiture : {accountType:"CreditVoiture", name: 'Voiture'},
    CreditImmobilier : {accountType:"CreditImmobilier", name: 'Immobilier'},
    CreditTravaux : {accountType:"CreditTravaux", name: 'Travaux'},
    CreditConsummation: {accountType: "CreditConsummation", name:"Credit à la consommation"},
    CreditAutre : {accountType:"CreditAutre", name: 'Autre'},
    PasCredit: {accountType:"PasCredit", name: "Pas de crédit"},
    CompteCurrent:{accountType:"CompteCurrent", name:"Compte courant"},
    Scpi:{accountType:"Scpi", name:"Société civile de placement immobilier"},
    Pea:{accountType:"Pea", name:"Plan d'epargne en action"},
    CompteTitre:{accountType:"CompteTitre", name:"Compte Titre"},
    Opcvm:{accountType:"Opcvm", name:"Organismes de Placement Collectif en Valeurs Mobilières (OPCVM)"},
    PasCurrent:{accountType:"PasCurrent", name:"Pas de compte courant"}
}